SubjectLinks = new (function () {
  this.setSelects = () => {
    let wrapper = $(".manage-subject-links");

    $("#subject-links-junior-cert-filter", wrapper).select2({
      placeholder: "- Filter by junior certificate -",
    });

    $("#subject-links-senior-cert-filter", wrapper).select2({
      placeholder: "- Filter by senior certificate -",
    });
  };
})();
